import { createSvgIcon } from '@automata/mui-theme';
export const TiprackIcon = createSvgIcon(
  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M74 19H64V29H61V18C61 16.8954 61.8954 16 63 16H75C76.1046 16 77 16.8954 77 18V29H74V19ZM75 41H71.9586L69 58.7517L66.0414 41H63L68.0136 71.0816C68.1993 72.1958 69.8007 72.1958 69.9864 71.0816L75 41ZM56 29V26C56 24.8954 55.1046 24 54 24H42C40.8954 24 40 24.8954 40 26V29H43V27H53V29H56ZM40.6667 41L47.0136 79.0816C47.1993 80.1958 48.8007 80.1958 48.9864 79.0816L55.3333 41H52.292L48 66.7517L43.708 41H40.6667ZM35 29V26C35 24.8954 34.1046 24 33 24H21C19.8954 24 19 24.8954 19 26V29H22V27H32V29H35ZM19.6667 41L26.0136 79.0816C26.1993 80.1958 27.8007 80.1958 27.9864 79.0816L34.3333 41H31.292L27 66.7517L22.708 41H19.6667Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M81 32H15V38H81V32ZM14 29C12.8954 29 12 29.8954 12 31V39C12 40.1046 12.8954 41 14 41H82C83.1046 41 84 40.1046 84 39V31C84 29.8954 83.1046 29 82 29H14Z"
    />
    <path d="M64 22H74V25H64V22Z" />
  </svg>,
  'TiprackIcon'
);
